import React from 'react';

export default function Loader() {
    return (
        <div class="preloader"></div>
    )
}


